// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__LoadingSpinner from "../../atoms/LoadingSpinner.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(item) {
  return function (columns) {
    return function (clickable) {
      return function (edgePadding) {
        return function (hasShadow) {
          return function (onItemClick) {
            return JsxRuntime.jsx("tr", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(columns, (function (index, column) {
                                    const Key = "row-td:" + String(index);
                                    const match = column.textAlign;
                                    return JsxRuntime.jsx("td", {
                                                children: Curry._1(column.content, item),
                                                className: Cn.fromList({
                                                      hd: "px-4 py-2 whitespace-nowrap bg-white border-b border-gray-main",
                                                      tl: {
                                                        hd: Cn.on("group-hover:bg-gray-100", clickable),
                                                        tl: {
                                                          hd: Cn.on("left-0", index === 0),
                                                          tl: {
                                                            hd: Cn.on("shadow-r", index === 0 && hasShadow),
                                                            tl: {
                                                              hd: Cn.on("pl-0", !edgePadding && index === 0),
                                                              tl: {
                                                                hd: Cn.on("pl-6", edgePadding && index === 0),
                                                                tl: {
                                                                  hd: Cn.on("max-w-0 w-full min-w-55", column.fillWidth),
                                                                  tl: {
                                                                    hd: match === "right" ? "text-right" : (
                                                                        match === "center" ? "text-center" : "text-left"
                                                                      ),
                                                                    tl: /* [] */0
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    })
                                              }, Key);
                                  }))),
                        className: Cn.fromList({
                              hd: "group",
                              tl: {
                                hd: Cn.on("cursor-pointer", clickable),
                                tl: /* [] */0
                              }
                            }),
                        onClick: (function (param) {
                            Curry._1(onItemClick, item);
                          })
                      });
          };
        };
      };
    };
  };
}

function GrpcItemsTable$Row(Props) {
  return Curry._4(make(Props.item)(Props.columns), Props.clickable, Props.edgePadding, Props.hasShadow, Props.onItemClick);
}

const Row = {
  make: GrpcItemsTable$Row
};

function make$1(columns) {
  return function (items) {
    return function (hasPaginationOpt) {
      const hasPagination = hasPaginationOpt !== undefined ? hasPaginationOpt : true;
      return function (hasDividerOpt) {
        const hasDivider = hasDividerOpt !== undefined ? hasDividerOpt : false;
        return function (clickableOpt) {
          const clickable = clickableOpt !== undefined ? clickableOpt : true;
          return function (edgePaddingOpt) {
            const edgePadding = edgePaddingOpt !== undefined ? edgePaddingOpt : true;
            return function (onItemClickOpt) {
              const onItemClick = onItemClickOpt !== undefined ? onItemClickOpt : (function (param) {
                    
                  });
              const match = React.useState(function () {
                    return 0;
                  });
              const setHOffset = match[1];
              const hOffset = match[0];
              const handleScroll = function ($$event) {
                const target = $$event.target;
                const offset = target.scrollLeft;
                Curry._1(setHOffset, (function (param) {
                        return offset;
                      }));
              };
              return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("table", {
                                        children: [
                                          JsxRuntime.jsx("thead", {
                                                children: JsxRuntime.jsx("tr", {
                                                      children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(columns, (function (index, column) {
                                                                  const Key = "header-" + String(index);
                                                                  const match = column.textAlign;
                                                                  return JsxRuntime.jsx("th", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                                          className: "whitespace-nowrap truncate text-gray-medium",
                                                                                          children: column.title
                                                                                        }),
                                                                                    className: Cn.fromList({
                                                                                          hd: "px-4 py-3  bg-white border-b border-gray-main bg-gray-pale",
                                                                                          tl: {
                                                                                            hd: Cn.on("pl-0", !edgePadding && index === 0),
                                                                                            tl: {
                                                                                              hd: Cn.on("pl-6", edgePadding && index === 0),
                                                                                              tl: /* [] */0
                                                                                            }
                                                                                          }
                                                                                        })
                                                                                  }),
                                                                              className: Cn.fromList({
                                                                                    hd: "sticky top-0 p-0 z-10",
                                                                                    tl: {
                                                                                      hd: Cn.on("shadow-r z-20", index === 0 && hOffset !== 0),
                                                                                      tl: {
                                                                                        hd: Cn.on("left-0", index === 0),
                                                                                        tl: {
                                                                                          hd: match === "right" ? "text-right" : (
                                                                                              match === "center" ? "text-center" : "text-left"
                                                                                            ),
                                                                                          tl: /* [] */0
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  })
                                                                            }, Key);
                                                                })))
                                                    })
                                              }),
                                          JsxRuntime.jsx("tbody", {
                                                children: typeof items === "string" || items.NAME !== "Data" ? null : Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(items.VAL, (function (index, item) {
                                                              const Key = "RequestItem-" + String(index);
                                                              return JsxRuntime.jsx(GrpcItemsTable$Row, {
                                                                          item: item,
                                                                          columns: columns,
                                                                          clickable: clickable,
                                                                          edgePadding: edgePadding,
                                                                          hasShadow: hOffset !== 0,
                                                                          onItemClick: onItemClick
                                                                        }, Key);
                                                            }))),
                                                className: Cn.fromList({
                                                      hd: "bg-white text-sm leading-5 text-cool-gray-900",
                                                      tl: {
                                                        hd: Cn.on("divide-y divide-cool-gray-200", hasDivider),
                                                        tl: /* [] */0
                                                      }
                                                    })
                                              })
                                        ],
                                        className: "min-w-full"
                                      }),
                                  className: Cn.fromList({
                                        hd: "max-w-100 overflow-auto relative",
                                        tl: {
                                          hd: Cn.on("flex-1", typeof items === "string" ? false : items.NAME === "Data"),
                                          tl: /* [] */0
                                        }
                                      }),
                                  onScroll: handleScroll
                                }),
                            typeof items === "string" ? (
                                items === "Loading" ? JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {}),
                                        className: "flex-1 w-full"
                                      }) : null
                              ) : (
                                items.NAME === "Error" ? JsxRuntime.jsx("div", {
                                        children: "ошибка",
                                        className: "flex-1 w-full  flex items-center justify-center"
                                      }) : null
                              )
                          ],
                          className: Cn.fromList({
                                hd: "flex flex-col",
                                tl: {
                                  hd: Cn.on("flex-1 h-0", hasPagination),
                                  tl: /* [] */0
                                }
                              })
                        });
            };
          };
        };
      };
    };
  };
}

function GrpcItemsTable(Props) {
  return Curry._5(make$1(Props.columns)(Props.items), Props.hasPagination, Props.hasDivider, Props.clickable, Props.edgePadding, Props.onItemClick);
}

const make$2 = GrpcItemsTable;

export {
  Row ,
  make$2 as make,
}
/* Buhta_cabinet__LoadingSpinner Not a pure module */
